import { Plus } from "lucide-react";

interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}

export default function FAQItem({
  question,
  answer,
  isOpen,
  onToggle,
}: FAQItemProps) {
  return (
    <div className="tw-border-b tw-border-gray-100 tw-py-8">
      <button
        onClick={onToggle}
        className="tw-w-full tw-flex tw-justify-between tw-items-center tw-text-left tw-gap-6 tw-group"
      >
        <span 
          className="tw-text-xl md:tw-text-2xl tw-font-semibold tw-text-black group-hover:tw-text-[#916B52] tw-transition-colors"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          {question}
        </span>

        <span
          className={`tw-shrink-0 tw-text-gray-400 tw-transition-transform tw-duration-500 ${
            isOpen ? "tw-rotate-45" : "tw-rotate-0"
          }`}
        >
          <Plus size={24} strokeWidth={2.5} />
        </span>
      </button>

      {/* Animated content */}
      <div
        className={`tw-grid tw-transition-all tw-duration-500 tw-ease-in-out ${
          isOpen ? "tw-grid-rows-[1fr] tw-opacity-100 tw-mt-6" : "tw-grid-rows-[0fr] tw-opacity-0"
        }`}
      >
        <div className="tw-overflow-hidden">
          <p 
            className="tw-text-lg md:tw-text-xl tw-text-gray-600 tw-leading-relaxed tw-max-w-3xl"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            {answer}
          </p>
        </div>
      </div>
    </div>

  );
}
